import { combineReducers } from '@reduxjs/toolkit';

import auth from '../feature/auth/store/reducer';
import categories from '../feature/categories/store/reducer';
import settings from '../feature/settings/store/reducer';

const reducer = combineReducers({ auth, settings, categories });

export default reducer;
